 export const bestdeal = [
    {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/329/original/data?1616795305",
        "name":"Alphonso Mango Devgad",
        "quantity":"6 pcs",
        "price":"479",
        "delprice":"534"
        },
           {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/028/original/data?1616765740",
        "name":"Brinjal Kateri, Baingan",
        "quantity":"250 g",
        "price":"11",
        "delprice":"14"
        },
          {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCHA12.png",
        "name":"Beans Chawli",
        "quantity":"250 g",
        "price":"12",
        "delprice":"19"
        },
          {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/250/original/data?1642167498",
        "name":"Lemon(100g) / Nimboo / Nibu",
        "quantity":"100g",
        "price":"21",
        "delprice":"27"
        },
          {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LMET1.png",
        "name":"Methi (Fenugreek Leaves)",
        "quantity":"100 g",
        "price":"11",
        "delprice":"17"
        }, {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/388/original/data?1624798076",
          "name":"Plum Imported",
          "quantity":"6 pcs\n470-530g",
          "price":"238"
          },{
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/442/original/data?1635063552",
            "name":"Smoothie Combo (Banana Robusta - 1Kg + Blueberry - 1 Pun...",
            "quantity":"1 unit",
            "price":"365"
            }, {
              "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBOT12.png",
              "name":"Bottle Gourd (Dudhi / Lauki)",
              "quantity":"1 pc\n(Approx 500 to 800 g)",
              "price":"9"
              } ,
              {
                "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/315/original/data?1614700255",
                "name":"Cucumber Green Indian / Kheera / Kakdi",
                "quantity":"500 g",
                "price":"18"
                }
 ]

 export const mangeos = [
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VMAN12.png",
  "name":"Mango Raw",
  "quantity":"250 g",
  "price":14
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FKES1.png",
  "name":"Mango Kesar",
  "quantity":"1 Kg",
  "price":219,
  "delprice":250
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/135/original/data?1612689931",
  "name":"Mango Badami",
  "quantity":"1 Kg",
  "price":129
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/004/597/original/data?1647577454",
  "name":"Mango Totapuri Raw",
  "quantity":"1 Kg",
  "price":108
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/329/original/data?1616795305",
  "name":"Alphonso Mango Devgad",
  "quantity":"6 pcs",
  "price":479,
  "delprice":534
  },
  {
      "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/339/original/data?1620237313",
      "name":"Alphonso Mango Devgad (2 x 6 pcs)",
      "quantity":"1 Dozen",
      "price":949,
      "delprice":1068
  },
  {
      "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/007/294/original/data?1650906368",
      "name":"Mango Mallika",
      "quantity":"1 Kg",
      "price":179
  },{
    "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FKES1.png",
    "name":"Mango Kesar",
    "price":"250",
    "quantity":"1 kg"
    },
    {
      "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/135/original/data?1612689931",
      "name":"Mango Badami",
      "price":"119",
      "quantity":"1 kg"
      },
      {
      "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/004/597/original/data?1647577454",
      "name":"Mango Totapuri Raw",
      "price":"144",
      "quantity":"1 Kg"
      },
      {
      "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/250/original/data?1621065378",
      "name":"Mango Lalbhag Sindhura",
      "price":"225",
      "quantity":"1 Kg"
      }
  ]

  
 export const fruits = [
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/006/original/data?1642616267",
  "name":"Apple Royal Gala",
  "quantity":"4 pcs\n500-600g",
  "price":"134"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FAVO21.png",
  "name":"Avocado Indian",
  "quantity":"1 pc",
  "price":"230"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FBAN24.png",
  "name":"Banana Elaichi / Yellaki",
  "quantity":"500 g",
  "price":"52"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FBAN14.png",
  "name":"Banana Robusta",
  "quantity":"1 kg",
  "price":"41"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FMOS13.png",
  "name":"Mosambi (Sweet Melon)",
  "quantity":"1 kg",
  "price":"122"
  },
  {
    "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/442/original/data?1635063552",
    "name":"Smoothie Combo (Banana Robusta - 1Kg + Blueberry - 1 Pun...",
    "quantity":"1 unit",
    "price":"365"
    },
    {
    "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/240/original/data?1642616123",
    "name":"Tasty Combo (2 Pcs Apple Royal Gala + 1 Kg Banana Robust...",
    "quantity":"1 unit",
    "price":"121"
    },
    {
    "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/204/original/data?1621240725",
    "name":"Cooler Fruit Combo (1 Pc Each Watermelon + Papaya)",
    "quantity":"1 Unit",
    "price":"79"
    }
  ]

  export const VEGETABLES = [
    {
    "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBEE12.png",
    "name":"Beetroot",
    "quantity":"500 g",
    "price":"16"
    },
    {
    "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/BONI11.png",
    "name":"Onion",
    "quantity":"1 kg",
    "price":"15"
    },
    {
    "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/101/original/data?1612451098",
    "name":"Pumpkin Green",
    "quantity":"500 g",
    "price":"15"
    },
    {
    "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VSWE12.png",
    "name":"Sweet Potato",
    "quantity":"500 g",
    "price":"40"
    },
    {
    "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VSUR12.png",
    "name":"Yam (Suran / Elephant Foot)",
    "quantity":"500 g",
    "price":"35"
    },
    {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCAU12.png",
      "name":"Cauliflower",
      "quantity":"1 pc\n(Approx 400- 700 gm)",
      "price":"35"
      },
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBIT12.png",
      "name":"Bitter Gourd (Karela)",
      "quantity":"500 g",
      "price":"23"
      },
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBOT12.png",
      "name":"Bottle Gourd (Dudhi / Lauki)",
      "quantity":"1 pc\n(Approx 500 to 800 g)",
      "price":"9"
      },
      {
      "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/028/original/data?1616765740",
      "name":"Brinjal Kateri, Baingan",
      "quantity":"250 g",
      "price":"10"
      },
    ]

    export const herbs = [
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCHI22.png",
      "name":"Chillies Green",
      "quantity":"100 g",
      "price":"9",
      "delprice":"13"
      },
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LCOR21.png",
      "name":"Coriander Leaves",
      "quantity":"100 g",
      "price":"15"
      },
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGAR12.png",
      "name":"Garlic Bunch",
      "quantity":"100 g",
      "price":"10"
      },
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGIN12.png",
      "name":"Ginger / Adrak",
      "quantity":"100 g",
      "price":"6"
      },
      {
      "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LMET1.png",
      "name":"Methi (Fenugreek Leaves)",
      "quantity":"100 g",
      "price":"11",
      "delprice":"17"
      },
      {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGIN12.png",
        "name":"Ginger / Adrak",
        "price":"6",
        "quantity":"100 g"
        },
        {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LCUR11.png",
        "name":"Curry Leaves",
        "price":"11",
        "quantity":"50 g"
        },
        {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCHI22.png",
        "name":"Chillies Green",
        "price":"10",
        "quantity":"100 g"
        },
        {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGAR32.png",
        "name":"Garlic Peeled",
        "price":"29",
        "quantity":"100 g"
        },
        {
        "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGAR12.png",
        "name":"Garlic Bunch / Lahsun / Vellulipaya",
        "price":"7",
        "quantity":"100 g"
        },
      ]

      export const dryfruits = [
        {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/578/original/data?1635085993",
        "name":"Cashew 200gms",
        "quantity":"200 g",
        "price":"182",
        "delprice":"332"
        },
        {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/579/original/data?1635086198",
        "name":"Cashew 500gms",
        "quantity":"500 g",
        "price":"450",
        "delprice":"830"
        },
        {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/580/original/data?1635086672",
        "name":"Cashew Tukda - 100gm",
        "quantity":"100 g",
        "price":"84",
        "delprice":"118"
        },
        {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/584/original/data?1635137208",
        "name":"Walnut 200gms",
        "quantity":"200 g",
        "price":"335",
        "delprice":"478"
        },
        {
        "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/585/original/data?1635137356",
        "name":"Walnut 500gms",
        "quantity":"500 g",
        "price":"825",
        "delprice":"1195"
        },
        {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/586/original/data?1635141850",
          "name":"Pista Salted - 100gms",
          "price":"115",
          "quantity":"100 g"
          },
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/577/original/data?1635085485",
          "name":"Cashew - 100gm",
          "price":"104",
          "quantity":"100 g"
          },
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/596/original/data?1635146122",
          "name":"Dry Dates - 200gms",
          "price":"70",
          "quantity":"200 g"
          },
        ]

        export const staples = [
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/435/original/data?1643108708",
          "name":"Maya Besan 500G",
          "quantity":"500 g",
          "price":"54",
          "delprice":"59"
          },
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/437/original/data?1643108712",
          "name":"Maya Chana Dal Premium 500G",
          "quantity":"500 g",
          "price":"57",
          "delprice":"60"
          },
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/438/original/data?1643108714",
          "name":"Maya Chana Dal Standerd 500G",
          "quantity":"500 g",
          "price":"49",
          "delprice":"58"
          },
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/439/original/data?1643108717",
          "name":"Maya Groundnut 500G",
          "quantity":"500 g",
          "price":"85",
          "delprice":"107"
          },
          {
          "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/440/original/data?1643108719",
          "name":"Maya Juwar Premium 1Kg",
          "quantity":"1 kg",
          "price":"56",
          "delprice":"61"
          },
          {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/382/original/data?1648552884",
            "name":"Maya Whole Spice Big Mustard Seeds, 100 g",
            "price":"17",
            "quantity":"100 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/468/original/data?1643128069",
            "name":"Maya Whole Spice Coriander 100G",
            "price":"30",
            "quantity":"100 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/477/original/data?1643128090",
            "name":"Maya Whole Spice Shahi Jeera 50G",
            "price":"42",
            "quantity":"50 g"
            },
          ]



          export const Masala = [
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/007/120/original/data?1649657414",
            "name":"Maya Whole Spice Black Cardamom, 50 g",
            "price":"79",
            "quantity":"50 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/382/original/data?1648552884",
            "name":"Maya Whole Spice Big Mustard Seeds, 100 g",
            "price":"17",
            "quantity":"100 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/468/original/data?1643128069",
            "name":"Maya Whole Spice Coriander 100G",
            "price":"30",
            "quantity":"100 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/477/original/data?1643128090",
            "name":"Maya Whole Spice Shahi Jeera 50G",
            "price":"42",
            "quantity":"50 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/007/119/original/data?1649657173",
            "name":"Maya Whole Spice Garam Masala, 100 g",
            "price":"71",
            "quantity":"100 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/081/original/data?1648280317",
            "name":"Maya Whole Spice Guntur Chilli 100g",
            "price":"40",
            "quantity":"100 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/475/original/data?1643128085",
            "name":"Maya Whole Spice Mustard Small 100G",
            "price":"17",
            "quantity":"100 g"
            },
            ]
            
            //Dals & Pulses
            export const Dals = [
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/504/original/data?1648720508",
            "name":"Maya Vatana Green 500G",
            "price":"72",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/437/original/data?1643108712",
            "name":"Maya Chana Dal Premium 500G",
            "price":"57",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/438/original/data?1643108714",
            "name":"Maya Chana Dal Standerd 500G",
            "price":"49",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/439/original/data?1643108717",
            "name":"Maya Groundnut 500G",
            "price":"85",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/440/original/data?1643108719",
            "name":"Maya Juwar Premium 1Kg",
            "price":"56",
            "quantity":"1 kg"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/441/original/data?1643108721",
            "name":"Maya Kabuli Chana Big 500G",
            "price":"82",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/442/original/data?1643108724",
            "name":"Maya Kabuli Chana Small 500G",
            "price":"77",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/444/original/data?1643108728",
            "name":"Maya Masoor Dal Split 500G",
            "price":"67",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/445/original/data?1643108731",
            "name":"Maya Matki 250G",
            "price":"36",
            "quantity":"250 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/446/original/data?1643108733",
            "name":"Maya Moong Dal Standard 1 Kg",
            "price":"143",
            "quantity":"1 kg"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/450/original/data?1643108741",
            "name":"Maya Rajma Kashmiri Red 500G",
            "price":"85",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/456/original/data?1643128043",
            "name":"Maya Soyabean 500G",
            "price":"77",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/459/original/data?1643128050",
            "name":"Maya Toor Dal Premium 1 Kg",
            "price":"139",
            "quantity":"1 kg"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/460/original/data?1643128052",
            "name":"Maya Urad Dal Premium 500G",
            "price":"77",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/481/original/data?1643128102",
            "name":"Maya Moong Dal Premium 1 Kg",
            "price":"146",
            "quantity":"1 kg"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/432/original/data?1643108701",
            "name":"Maya Vatana White 500G",
            "price":"63",
            "quantity":"500 g"
            },
            ]
            
            //Atta, Flour and Sooji
            export const Atta = [
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/435/original/data?1643108708",
            "name":"Maya Besan 500G",
            "price":"54",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/443/original/data?1643108726",
            "name":"Maya Maida 500G",
            "price":"27",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/449/original/data?1643108739",
            "name":"Maya Premium Suji 500G",
            "price":"27",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/451/original/data?1643128032",
            "name":"Maya Rava 500G",
            "price":"30",
            "quantity":"500 g"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/480/original/data?1643128099",
            "name":"Maya Chakki Fresh Atta 5 Kg",
            "price":"230",
            "quantity":"5 kg"
            },
            ]
            
            //Rice & Rice Products
            export const Rice = [
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/083/original/data?1648280734",
            "name":"Maya HMT Kolam Rice, 5kg",
            "price":"351",
            "quantity":"5 kg"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/084/original/data?1648280911",
            "name":"Maya Indrayani Rice, 5 Kg",
            "price":"355",
            "quantity":"5 kg"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/005/085/original/data?1648281362",
            "name":"Maya Surti Kolam Rice, 5kg",
            "price":"446",
            "quantity":"5 kg"
            }
            ]
            
            export const dryfruitsdata = [
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/263/original/data?1642176073",
              "name":"Cashew & Kismis Combo Pack ",
              "price":"149",
              "quantity":"1 unit-300 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/579/original/data?1635086198",
              "name":"Cashew 500gms",
              "price":"450",
              "quantity":"500 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/583/original/data?1635137039",
              "name":"Walnut - 100gms",
              "price":"175",
              "quantity":"100 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/580/original/data?1635086672",
              "name":"Cashew Tukda - 100gm",
              "price":"84",
              "quantity":"100 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/586/original/data?1635141850",
              "name":"Pista Salted - 100gms",
              "price":"115",
              "quantity":"100 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/577/original/data?1635085485",
              "name":"Cashew - 100gm",
              "price":"104",
              "quantity":"100 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/596/original/data?1635146122",
              "name":"Dry Dates - 200gms",
              "price":"70",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/593/original/data?1635144647",
              "name":"Kismis - 200 gms",
              "price":"59",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/591/original/data?1635143661",
              "name":"Almond 200gms (Pack of 2*100gms)",
              "price":"206",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/585/original/data?1635137356",
              "name":"Walnut 500gms ",
              "price":"825",
              "quantity":"500 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/595/original/data?1635145018",
              "name":"Kismis - 1 Kg ",
              "price":"289",
              "quantity":"1 kg"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/598/original/data?1635146504",
              "name":"Dry Dates - 1 Kg ",
              "price":"330",
              "quantity":"1 kg"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/597/original/data?1635146300",
              "name":"Dry Dates - 400gms ",
              "price":"135",
              "quantity":"400 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/587/original/data?1635142002",
              "name":"Pista Salted 200gms ",
              "price":"229",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/594/original/data?1635144809",
              "name":"Kismis - 400 gms",
              "price":"116",
              "quantity":"400 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/578/original/data?1635085993",
              "name":"Cashew 200gms ",
              "price":"182",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/584/original/data?1635137208",
              "name":"Walnut 200gms ",
              "price":"335",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/590/original/data?1635143515",
              "name":"Almond - 100gms",
              "price":"115",
              "quantity":"100 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/588/original/data?1635142184",
              "name":"Pista Kernel - 100gms",
              "price":"175",
              "quantity":"100 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/592/original/data?1635143799",
              "name":"Almond 500gms ",
              "price":"489",
              "quantity":"500 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/581/original/data?1635086887",
              "name":"Cashew Tukda 200gms ",
              "price":"167",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/582/original/data?1635086999",
              "name":"Cashew Tukda 500gms ",
              "price":"415",
              "quantity":"500 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/589/original/data?1635142329",
              "name":"Pista Kernel 200gms ",
              "price":"345",
              "quantity":"200 g"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/159/original/data?1595448691",
              "name":"Dates Kimia",
              "price":"199",
              "quantity":"500g"
              }
              ]   

              export const applesdata = [
                //Apples, Pears, Plums
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/006/original/data?1642616267",
            "name":"Apple Royal Gala",
            "quantity":"4 pcs\n500-600g",
            "price":"149"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/244/original/data?1613050070",
            "name":"Wood Apple",
            "quantity":"1 Pc",
            "price":"18"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/096/original/data?1625415915",
            "name":"Pear Green / Packham",
            "quantity":"500 g",
            "price":"122"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/241/original/data?1610967581",
            "name":"Apple Red Delicious",
            "quantity":"4 Pc\nApprox. 500g- 650g",
            "price":"179"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FAPP23.png",
            "name":"Apple Green / Granny Smith",
            "quantity":"4 pcs",
            "price":"243"
            },
          ]
          
          export const orangedata = [
          //Oranges, Mosambi & Melons
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FMOS13.png",
            "name":"Mosambi (Sweet Melon)",
            "quantity":"1 kg",
            "price":"122"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FCOC1.png",
            "name":"Coconut",
            "quantity":"1 pc",
            "price":"31"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FMUS1.png",
            "name":"Musk Melon/ Kharabooja",
            "quantity":"1 pc\n(Aprox 650 to 1200 g)",
            "price":"62"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/117/original/data?1616765390",
            "name":"Watermelon",
            "quantity":"1 pc\n(Approx 1.5 to 2.7 kg)",
            "price":"44"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/338/original/data?1620150734",
            "name":"Orange Imported",
            "quantity":"2 Pcs",
            "price":"38"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/257/original/data?1612448669",
            "name":"Coconut Tender / Nariyal Pani",
            "quantity":"1 Pc",
            "price":"49"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/004/598/original/data?1647718256",
            "name":"Special Offer Watermelon",
            "quantity":"1 pc\n1.5 - 2.7 kg",
            "price":"9"
            },
          ]

          export const grapedata = [
            //Grapes, Banana, Guava & Sapota
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FBAN14.png",
            "name":"Banana Robusta",
            "quantity":"1 kg",
            "price":"49"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FBAN24.png",
            "name":"Banana Elaichi / Yellaki",
            "quantity":"500 g",
            "price":"52"
            },
            
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FCHI13.png",
            "name":"Chikoo",
            "quantity":"500 g",
            "price":"34"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/247/original/data?1612371028",
            "name":"Banana Nendran",
            "quantity":"500 g",
            "price":"81"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/369/original/data?1622631944",
            "name":"Guava White Indian",
            "quantity":"2 Pcs\n(600 - 800g)",
            "price":"79"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/260/original/data?1612450264",
            "name":"Banana Raw",
            "quantity":"500 g",
            "price":"27"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/248/original/data?1612379941",
            "name":"Banana Red",
            "quantity":"500 g",
            "price":"62"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FGRA42.png",
            "name":"Grapes Green",
            "quantity":"500 g",
            "price":"66"
            },
          ]
            
          export const exoticfruitdata = [
            //Exotic Fruits
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/432/original/data?1629889583",
            "name":"Grape Fruit",
            "quantity":"1 Pc",
            "price":"105"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FAVO21.png",
            "name":"Avocado Indian",
            "quantity":"1 pc",
            "price":"230"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FBLU1.png",
            "name":"Blueberry",
            "quantity":"1 unit\n(125 g)",
            "price":"319"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FDRA1.png",
            "name":"Dragon Fruit",
            "quantity":"1 pc",
            "price":"72"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FKIW2.png",
            "name":"Kiwi Green",
            "quantity":"1 unit\n(3 pcs)",
            "price":"91"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/235/original/data?1610033950",
            "name":"Avocado Imported",
            "quantity":"1 pc",
            "price":"321"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FANJ2.png",
            "name":"Anjeer (Figs)",
            "quantity":"1 unit\n6-8 Pcs",
            "price":"78"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/243/original/data?1611939790",
            "name":"Mulberry",
            "quantity":"1 Unit\n(Approx 100-125 g)",
            "price":"108"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/388/original/data?1624798076",
            "name":"Plum Imported",
            "quantity":"6 pcs\n470-530g",
            "price":"238"
            },
          ]
          
          export const fruitcombodata = [
          //Combos
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/442/original/data?1635063552",
            "name":"Smoothie Combo (Banana Robusta - 1Kg + Blueberry - 1 Pun...",
            "quantity":"1 unit",
            "price":"365"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/240/original/data?1642616123",
            "name":"Tasty Combo (2 Pcs Apple Royal Gala + 1 Kg Banana Robust...",
            "quantity":"1 unit",
            "price":"121"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/204/original/data?1621240725",
            "name":"Cooler Fruit Combo (1 Pc Each Watermelon + Papaya)",
            "quantity":"1 Unit",
            "price":"79"
            }
            ]


            export const mangodata = [
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/329/original/data?1616795305",
              "name":"Alphonso Mango Devgad",
              "price":"479",
              "quantity":"6 pcs\n(Approx 200 g to 220 g per Pc)"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/135/original/data?1612689931",
              "name":"Mango Badami",
              "price":"119",
              "quantity":"1 kg"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/004/597/original/data?1647577454",
              "name":"Mango Totapuri Raw",
              "price":"144",
              "quantity":"1 Kg"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/250/original/data?1621065378",
              "name":"Mango Lalbhag Sindhura",
              "price":"225",
              "quantity":"1 Kg"
              },
              {
              "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VMAN12.png",
              "name":"Mango Raw",
              "price":"14",
              "quantity":"250 g"
              },
              {
              "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/FKES1.png",
              "name":"Mango Kesar",
              "price":"250",
              "quantity":"1 kg"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/339/original/data?1620237313",
              "name":"Alphonso Mango Devgad (2 x 6 pcs)",
              "price":"949",
              "quantity":"1 Dozen"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/007/294/original/data?1650906368",
              "name":"Mango Mallika",
              "price":"139",
              "quantity":"1 kg"
              }
              ]

              export const dailyvegetables = [
                //daily vegies
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBRI12.png",
            "name":"Brinjal Bharta",
            "quantity":"500 g",
            "price":"24"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/101/original/data?1612451098",
            "name":"Pumpkin Green",
            "quantity":"500 g",
            "price":"16"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCAP12.png",
            "name":"Capsicum (Shimla), Green Shimla Mirchi",
            "quantity":"250 g",
            "price":"13"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/315/original/data?1614700255",
            "name":"Cucumber Green Indian / Kheera / Kakdi",
            "quantity":"500 g",
            "price":"18"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCAB12.png",
            "name":"Cabbage",
            "quantity":"1 pc\n(Approx 500 to 800 g)",
            "price":"6"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCAU12.png",
            "name":"Cauliflower",
            "quantity":"1 pc\n(Approx 400- 700 gm)",
            "price":"35"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBIT12.png",
            "name":"Bitter Gourd (Karela)",
            "quantity":"500 g",
            "price":"23"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBOT12.png",
            "name":"Bottle Gourd (Dudhi / Lauki)",
            "quantity":"1 pc\n(Approx 500 to 800 g)",
            "price":"9"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/028/original/data?1616765740",
            "name":"Brinjal Kateri, Baingan",
            "quantity":"250 g",
            "price":"10"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VDRU12.png",
            "name":"Drumstick",
            "quantity":"100 g",
            "price":"4"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/106/original/data?1603884029",
            "name":"Snake Gourd (Bada Parwal)",
            "quantity":"250 g",
            "price":"20"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/316/original/data?1614700848",
            "name":"Cucumber White",
            "quantity":"500 g",
            "price":"23"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VBRI22.png",
            "name":"Brinjal Black / Nagpur",
            "quantity":"500 g",
            "price":"17"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/006/625/original/data?1649244316",
            "name":"Ridge Gourd (Turai) 500 g",
            "quantity":"500 g",
            "price":"26"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGAV12.png",
            "name":"Beans Cluster (Gavar)",
            "quantity":"250 g",
            "price":"12"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VTON12.png",
            "name":"Tondli",
            "quantity":"500 g",
            "price":"33"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VFRE12.png",
            "name":"Beans French",
            "quantity":"500 g",
            "price":"80"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCHA12.png",
            "name":"Beans Chawli",
            "quantity":"250 g",
            "price":"14"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VSPO12.png",
            "name":"Sponge Gourd (Galka)",
            "quantity":"500 g",
            "price":"32"
            },
            {
            "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VTIN12.png",
            "name":"Tinda",
            "quantity":"250 g",
            "price":"27"
            },
            {
            "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/006/624/original/data?1649243792",
            "name":"Lady's Finger (Bhindi / Okra / Bhendi)",
            "quantity":"500 g",
            "price":"18"
            },
             ]
              
             export const oniondata = [
              {
              "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VPUM12.png",
              "name":"Pumpkin Red",
              "quantity":"500 g",
              "price":"19"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/164/original/data?1629975839",
              "name":"Ash Gourd (White Pumpkin)",
              "quantity":"500 g",
              "price":"29"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/images/images/000/006/605/original/data?1649242645",
              "name":"Tomato (1 Kg)",
              "quantity":"1 kg",
              "price":"40"
              },
              {
              "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/BONI11.png",
              "name":"Onion",
              "quantity":"1 kg",
              "price":"14"
              },
              {
              "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/BPOT11.png",
              "name":"Potato / Batata",
              "quantity":"1 kg",
              "price":"29"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/236/original/data?1610137718",
              "name":"Tomato - Cherry",
              "quantity":"200 g",
              "price":"21"
              },
              {
              "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/234/original/data?1610025881",
              "name":"Onion - Sambhar",
              "quantity":"250 g",
              "price":"22"
              },
              ]  
              export const rootdata = [
                //Root Vegetables
                {
                "name":"Beetroot",
                "quantity":"500 g",
                "price":"16"
                },
                {
                "name":"Arbi (Colocasia)",
                "quantity":"500 g",
                "price":"34"
                },
                {
                "name":"Yam (Suran / Elephant Foot)",
                "quantity":"500 g",
                "price":"36"
                },
                {
                "name":"Carrot Orange (Local)",
                "quantity":"500 g",
                "price":"22"
                },
                {
                "name":"Radish",
                "quantity":"500 g",
                "price":"25"
                },
                {
                "name":"Yam Purple (Kandh)",
                "quantity":"250 g",
                "price":"25"
                },
                {
                "name":"Sweet Potato",
                "quantity":"500 g",
                "price":"40"
                },
                ]
                
                export const exoticvegetabledata = [
                //Exotic Vegetables
                {
                "name":"Pumpkin Disco",
                "quantity":"250 g",
                "price":"22"
                },
                {
                "name":"Mushroom Button",
                "quantity":"1 unit\n(200 g)",
                "price":"37"
                },
                {
                "name":"Basil Italian",
                "quantity":"50 g",
                "price":"6"
                },
                {
                "name":"Capsicum Yellow / Bell Pepper",
                "quantity":"2pcs(250-350g)",
                "price":"102"
                },
                {
                "name":"Lettuce Iceberg",
                "quantity":"300-550gm",
                "price":"139"
                },
                {
                "name":"Cabbage Red",
                "quantity":"1 pc\n(Approx 500 g)",
                "price":"45"
                },
                {
                "name":"Baby Potato",
                "quantity":"500 g",
                "price":"23"
                },
                {
                "name":"Banana Flower",
                "quantity":"1 Pc",
                "price":"35"
                },
                {
                "name":"Broccoli",
                "quantity":"(450g-550g)",
                "price":"156"
                },
                {
                "name":"Sweet Corn Bunch (Bhutta)",
                "quantity":"1 pc\n(Aprox 200 to 400 g)",
                "price":"16"
                },
                {
                "name":"Celery",
                "quantity":"250 g",
                "price":"19"
                },
                {
                "name":"Capsicum Red",
                "quantity":"2 Pcs\n(250-300 gms)",
                "price":"102"
                },
                ]

                export const exoticvegcombodata = [
                  //Vegetable Combos
                  {
                  "name":"Fresh Salad Combo (250G Carrot + 500 G Cucumber)",
                  "quantity":"1 unit",
                  "price":"27"
                  },
                  {
                  "name":"Mixed Capsicum Combo (1 Pc Capsicum Red + 1 Pc Capsicum ...",
                  "quantity":"1 unit",
                  "price":"99"
                  },
                  {
                  "name":"UPVAS Combo (500 gm Sweet Potato + 500 gm Arbi + 1 Kg Po...",
                  "quantity":"1 unit",
                  "price":"100"
                  }
                  ]

                  
export const herbsdata = [
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/276/original/data?1642317197",
  "name":"Masala Combo",
  "price":"39",
  "quantity":"1 unit"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/419/original/data?1635147438",
  "name":"Colocasia Leaves",
  "price":"2",
  "quantity":"1 Pc"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/163/original/data?1640321543",
  "name":"Special Offer Coriander",
  "price":"4",
  "quantity":"1 unit\nApprox 100 g"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/003/250/original/data?1642167498",
  "name":"Lemon(100g) / Nimboo / Nibu",
  "price":"19",
  "quantity":"100g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGIN12.png",
  "name":"Ginger / Adrak",
  "price":"6",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LCUR11.png",
  "name":"Curry Leaves",
  "price":"11",
  "quantity":"50 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VCHI22.png",
  "name":"Chillies Green",
  "price":"10",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGAR32.png",
  "name":"Garlic Peeled",
  "price":"29",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VGAR12.png",
  "name":"Garlic Bunch / Lahsun / Vellulipaya",
  "price":"7",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LCOR21.png",
  "name":"Coriander Leaves / Dhania / Kothimbir",
  "price":"13",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LMET1.png",
  "name":"Methi (Fenugreek Leaves)",
  "price":"17",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LSPI11.png",
  "name":"Palak Spinach",
  "price":"30",
  "quantity":"250 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/VAWL11.png",
  "name":"Amla",
  "price":"42",
  "quantity":"250 g"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/417/original/data?1628778604",
  "name":"Aloevera",
  "price":"13",
  "quantity":"1 Pc"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/380/original/data?1635063619",
  "name":"Banana Stem",
  "price":"33",
  "quantity":"1 Pc"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LMIN11.png",
  "name":"Mint Leaves / Pudina",
  "price":"7",
  "quantity":"100 g"
  },
  {
  "image":"https://fraazo-master.s3.ap-south-1.amazonaws.com/products/LSPR11.png",
  "name":"Spring Onion",
  "price":"14",
  "quantity":"250 g"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/602/original/data?1635155510",
  "name":"Betel Leaf - 12 Pcs",
  "price":"30",
  "quantity":"12 Pcs"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/375/original/data?1623816989",
  "name":"Turmeric",
  "price":"15",
  "quantity":"250g"
  },
  {
  "image":"https://s3.ap-south-1.amazonaws.com/fraazo-prod/products/product_images/000/000/162/original/data?1598301503",
  "name":"Amaranthus Red",
  "price":"23",
  "quantity":"250 g"
  }
  ]
  